// The 📍 under a remote punch's time in the attendance table: the area name
// (or the office name, when the remote employee punched at a work location)
// as a small button that opens the map.
import React, { useState } from "react";
import { MapPin } from "lucide-react";
import PunchLocationModal from "./PunchLocationModal";
import { rpText } from "./remotePunchText";
import { areaNameFor } from "./remotePunchApi";

export default function PunchPin({ punch, kind, employeeName, theme, language }) {
  const [open, setOpen] = useState(false);
  if (!punch) return null;
  const t = rpText(language);
  const dark = theme === "dark";
  const label = punch.locationName || areaNameFor(punch, language) || t.showOnMap;

  return (
    <>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        title={t.showOnMap}
        aria-label={`${t.showOnMap}: ${label}`}
        style={{
          marginTop: 3,
          maxWidth: "100%",
          display: "inline-flex",
          alignItems: "center",
          gap: 4,
          padding: "1px 7px 1px 5px",
          fontFamily: "inherit",
          fontSize: 10.5,
          fontWeight: 600,
          lineHeight: 1.6,
          borderRadius: 4,
          cursor: "pointer",
          border: `1px solid ${dark ? "rgba(248,113,113,0.35)" : "rgba(220,38,38,0.25)"}`,
          background: dark ? "rgba(220,38,38,0.12)" : "rgba(220,38,38,0.06)",
          color: dark ? "#fecaca" : "#b91c1c",
          direction: language === "ar" ? "rtl" : "ltr",
        }}
      >
        <MapPin size={11} style={{ flexShrink: 0, alignSelf: "flex-start", marginTop: 3 }} />
        {/* Up to two lines, so an area name stays readable in narrow cards. */}
        <span style={{ overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", textAlign: "start", lineHeight: 1.45 }}>{label}</span>
      </button>
      {open && (
        <PunchLocationModal
          punch={punch}
          kind={kind}
          employeeName={employeeName}
          theme={theme}
          language={language}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
